import { IconProps } from "./";
import Icon from "./assets/job_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24Job(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
